import React, { useEffect, useState, useContext, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Editor from "../../../Pages/Editor/Editor";
import CoverEditor from "../../../Pages/CoverEditor/Editor";
import "./PreviewResume.scss";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";

// import { onmessage } from "../../../workers/preview-worker";

function PreviewResume(props) {
  const ref = useRef();
  const { id } = useParams();
  const dispatch = useDispatch();
  const path = window.location.pathname;
  const history = useHistory();

  const { preview, setPreview } = useContext(ResumePopupContext);
  const { json, isJson, setIsJson, setIsSample } =
    useContext(jsonEditorContext);
  useEffect(() => {
    if (props.showPreview) {
      setPreview(true);
    }
  }, [props.showPreview]);

  const handleClose = (e) => {
    setIsSample(false);
    setIsJson(false);
    props.hidePreview();
    setPreview(false);
    props.setIsSample(false);
  };

  return (
    <>
      <Modal
        className="preview-resume-modal "
        show={props.showPreview}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        onEscapeKeyDown={() => handleClose()}
        onHide={() => handleClose()}
      >
        <Modal.Body className="preview-resume-modal-body">
          <img
            onClick={() => handleClose()}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="preview_scale">
            {path && path.includes("cover") ? (
              <CoverEditor preview={true} previewModal={true} sample={true} />
            ) : path && path.includes("resume") ? (
              <Editor preview={true} previewModal={true} sample={true} />
            ) : path && path.includes("reviewimagegenerate") ? (
              <Editor preview={true} previewModal={true} sample={true} />
            ) : (
              ""
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PreviewResume;
